import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools"; // Import the missing package
import HomePage from "./pages/HomePage";
import DimensionStepper from "./pages/DimensionStepper";
import Result from "./pages/Result";
import HubspotForm from "./pages/HubspotForm";

const queryClient = new QueryClient();

function App() {
  return (
    <div>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HubspotForm />} />
            <Route path="/HomePage" element={<HomePage />} />
            <Route path="/Dimensions" element={<DimensionStepper />} />
            <Route path="/Result" element={<Result />} />
          </Routes>
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </div>
  );
}

export default App;
